export default "__VITE_ASSET__cedeeefe__"